import WelcomePage from "../../Components/WelcomePage";
import WhatIsUs from "../../Components/WhatIsUs";
import CustomerReviews from "../../Components/CustomerReviews";
import SmallContactForm from "../../Components/SmallContactForm";
import PageLayout from "../../Components/Common/PageLayout";
import SEO from "../../Components/Common/SEO";
import "./style.scss";

const Home: React.FC = () => {
  return (
    <PageLayout className="Home">
      <SEO
        title="Professional Window Cleaning in Farnham"
        description="Farnham and District Window Cleaning offers expert residential and commercial window cleaning, gutter maintenance, and conservatory cleaning since 1972."
      />
      <WelcomePage />
      <WhatIsUs order="odd" />
      <CustomerReviews order="even" />
      <SmallContactForm order="odd" />
    </PageLayout>
  );
};

export default Home;
